import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'src/app/auth.service';

export const isAdminOrIntegrationGuard: CanActivateFn = () => {
	const authService = inject( AuthService );
	const router = inject( Router );

	const user = authService.user;
	if ( user?.isAdmin ) {
		return true;
	}

	return router.createUrlTree( ['/access-denied'] );
};

